module.exports = __webpack_public_path__ + "static/media/foto8.5242977a.png";